import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return(
        <button onClick = { () => window.scrollTo(0, 0) }
            style = { { width : "32px", height : "32px", background : "none", border : "none", color : "var(--black56)" } } >
            up
        </button>
    );
}